import { useEffect, Fragment, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { FilterRight, Search } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { getBlogActions, getPostSearch } from "Redux/Actions/BlogActions";

import Pagination from "../Pagination/Pagination";
import EachBlog from "./EachBlog";
import { dispatchItemToRedux } from "Redux/Actions";
import ReducerTypes from "Redux/Types/ReducerTypes";

// const options1 = [
//   {
//     label: "جدید ترین ها",
//     value: "new",
//   },
//   {
//     label: "برترین ها ",
//     value: "stars",
//   },
// ];

const AllBlogs = () => {
  const dispatch = useDispatch();
  const [ifSearch, setIfSearch] = useState(false);
  const [spinerLoading, setSpinerLoading] = useState(false);
  const [serchLoading, setSerchLoading] = useState(false);

  const blogs = useSelector((state) => state.blog?.blogs?.items);
  const pagination = useSelector((state) => state.blog?.blogs?.paginationData);
  const blogsParams = useSelector((state) => state.blog?.blogsParams);
  const loading = useSelector((state) => state.app.appLoading);

  const scrollTop = useRef();

  function inputOnKeyUpHandle(event) {
    // if (event.key === "space") {
    //   event.target.blur();
    // }
    if (event.code === "Space") {
      event.target.blur();

    }
  }

  useEffect(() => {
    dispatch(getBlogActions(blogsParams.page));
  }, [blogsParams]);

  const handleSearch = (value) => {
    if (value.trim().length === 0) {
      setSerchLoading(false);
      setIfSearch(false);
      setSpinerLoading(false);
      dispatch(getBlogActions(blogsParams.page));
    } else if (value.trim().length <= 2 && value.trim().length > 0) {
      setSerchLoading(true);
      setIfSearch(false);
      setSpinerLoading(true);
    } else if (value.trim().length > 2) {
      setIfSearch(true);
      setSpinerLoading(false);
      dispatch(getPostSearch(value));
    }
  };

  return (
    <div className="all-media-div container p-0">
      <div
        className="filter-box-sub-category  d-flex justify-content-end align-items-center  bg-shiri py-2 px-1 mb-4 align-items-center "
        ref={scrollTop}
      >
        {/* <FilterRight
          className="filter-bar-icon ms-2 border-start border-start ps-1"
          size={30}
        />
        <p className="how-filter m-0 ms-2 text-nowrap ">فیلتر بر اساس </p>
        <div className="select-boxes d-flex justify-content-between align-items-center ms-auto">
          <select className="select-filter ms-2 border-0 rounded-pill px-2 cursor-po bg-white">
            {options1.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div> */}
        <form className=" ">
          <input
            type="text"
            placeholder="جستجو در مقالات و مطالب"
            className="search-media-dappapp border-0 p-2"
            onKeyUp={inputOnKeyUpHandle}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <button
            className="border-0 p-2  bg-white"
            type="submit"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <Search className="bg-white" />
          </button>
        </form>
      </div>
      <div className="all-media-boxes  d-flex justify-content-between flex-wrap ">
        {loading || spinerLoading ? (
          <Fragment>
            <div className=" w-100 text-center ">
              <Spinner animation="border" variant="primary" />
            </div>
            {serchLoading ? (
              <p className="text-center mt-3 w-100">حداقل 3 کاراکتر ...</p>
            ) : null}
          </Fragment>
        ) : blogs?.length !== 0 ? (
          blogs.map((eachBlog) => {
            return (
              <div key={eachBlog.id} className="each-general-media">
                <Link
                  to={{
                    pathname: `/blog/${eachBlog.id}`,
                    state: { eachBlog },
                  }}
                >
                  <EachBlog eachBlog={eachBlog} />
                </Link>
              </div>
            );
          })
        ) : (
          <p className=" bg-shiri w-100 text-center p-3">لیست خالی است</p>
        )}
      </div>
      {pagination ? (
        pagination.last_page === 1 ? null : (
          <Pagination
            ifSearch={ifSearch}
            current_page={pagination.current_page}
            last_page={pagination.last_page}
            first_page_url={pagination.first_page_url}
            scrollTop={scrollTop}
          />
        )
      ) : null}
    </div>
  );
};

export default AllBlogs;
